import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyCheckboxInput } from '../../../../../components/common/survey/inputs/SurveyCheckboxInput';
import { SurveyInputContainer } from '../../../../../components/common/survey/inputs/SurveyInputContainer';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { joinProcessConstants } from '../../../../../constants/joinProcess';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessCropTypePage = () => {
  const navigate = useNavigate();

  const [selectedCropType, setSelectedCropType] = useState<string[]>([]);

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  const confirmHandler = () => {
    dispatch(userJoinActions.changeCropType(selectedCropType.join(',')));
    navigate('/join-process/crop-name', { replace: true });
  };

  return (
    <JoinProcessPageWrapper
      headerTitle={'어떤 작물을 재배중이신가요?'}
      canConfirm={selectedCropType.length >= 1}
      confirmHandler={confirmHandler}
    >
      <SurveyForm>
        <SurveyInputHeader inputTitle={'재배 작물 선택'} canDuplicate />

        <SurveyInputContainer gridColumns={1}>
          {joinProcessConstants.cropType.values.map((value, index) => (
            <SurveyCheckboxInput
              key={value}
              title={value}
              label={
                joinProcessConstants.cropType.labels && joinProcessConstants.cropType.labels.length > 0
                  ? joinProcessConstants.cropType.labels[index]
                  : undefined
              }
              onClick={() => {
                if (selectedCropType.includes(value)) {
                  setSelectedCropType((prev) => prev.filter((selectedValue) => selectedValue !== value));
                } else {
                  setSelectedCropType((prev) => [...prev, value]);
                }
              }}
              isChecked={selectedCropType.includes(value)}
            />
          ))}
        </SurveyInputContainer>
      </SurveyForm>
    </JoinProcessPageWrapper>
  );
};
